import { AtSign } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useT } from "@/lib/i18n";

/**
 * Visual parity with reference admin. Mentions data source (staff_mentions table)
 * doesn't exist yet for Vīnoga; shows the empty-state popover until wired.
 */
export function StaffMentionsDropdown() {
  const t = useT();
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative p-2 text-muted-foreground outline-none transition-colors hover:text-foreground">
          <AtSign size={20} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 overflow-hidden border-border p-0 shadow-xl" align="end">
        <div className="flex items-center justify-between border-b border-border bg-muted/50 px-4 py-3">
          <div className="flex flex-col">
            <h3 className="font-display text-sm font-bold text-foreground">
              {t("topnav.mentionsTitle", "Mentions")}
            </h3>
            <p className="font-body text-[10px] uppercase tracking-wider text-muted-foreground">
              {t("topnav.mentionsSubtitle", "Internal Notes")}
            </p>
          </div>
        </div>
        <div className="max-h-[400px] overflow-y-auto">
          <div className="flex flex-col items-center gap-2 p-8 text-center text-xs text-muted-foreground">
            <span className="font-body text-[11px] italic opacity-60">
              {t("topnav.mentionsEmpty", "No recent mentions")}
            </span>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
